import { InformationCircleIcon } from '@hugeicons/react'
import { useWatch } from 'react-hook-form'

import { sanitizeHtml } from '@/shared/lib/html/sanitize'

import { useResourceContext } from '@/shared/ui/Resource'

export const DigitalProductStoreBottomSheetDescription = ({}) => {
  const { description, reward_items } = useResourceContext()

  /* A auto-retirada é da variação, não da recompensa: o selo acompanha a
     variação selecionada em `Variations`, porque é dela que o resgate vai
     fechar sem passar pela lojinha — a irmã pode não ter. */
  const selectedVariationId = useWatch({ name: 'reward_item_id' })
  const auto_redeem = Boolean(
    (reward_items || []).find(item => item.id === selectedVariationId)
      ?.auto_redeem
  )

  if (!description && !auto_redeem) return null
  return (
    <div>
      <hr className="my-2 mb-4 border-gray-400" />
      {auto_redeem && (
        <span
          className="inline-flex items-center gap-1 bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded mb-3"
          title="Após resgatar você não precisar ir até a lojinha para realizar a retirada"
        >
          <InformationCircleIcon
            width={16}
            height={16}
            variant="bulk"
            className="mr-1"
          />
          Este é um item com auto-retirada
        </span>
      )}
      <p className="mb-1">
        <strong>Descrição</strong>
      </p>
      <div
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
        className="text-sm block max-h-[150px] overflow-y-auto"
      />
    </div>
  )
}
